import { useEffect } from "react";
import { useParams } from "react-router-dom";
import PublicPageView from "@/components/PublicPageView";
import { businesses } from "@/data/businesses";

export default function PublicBusinessPage() {
    const { slug } = useParams();
    const business = businesses[slug];

    useEffect(() => {
        if (business?.name?.en) {
            document.title = business.name.en;
        }
    }, [business]);

    if (!business) {
        return (
            <div className="public-page-root flex items-center justify-center bg-[#0F0F11] text-white p-6 text-center">
                <div>
                    <div className="text-6xl mb-4">·</div>
                    <h1 className="font-display text-2xl font-bold">
                        Page not available
                    </h1>
                    <p className="mt-2 text-sm text-white/60">
                        This NFC page is inactive or does not exist.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div
            data-testid="public-nfc-page"
            className="public-page-root"
            style={{
                backgroundColor: business.background_color || "#0B0B0F",
            }}
        >
            <PublicPageView business={business} />
        </div>
    );
}
